/**
 * Visibility Card — Centralized Frontend Configuration
 *
 * All display settings, colors, icons, and labels for the visibility card.
 * Edit this file to adjust the UI without touching component logic.
 */
import { Store, Globe, Share2 } from 'lucide-react';

// ── Score color thresholds ──────────────────────────────────────
export const SCORE_THRESHOLDS = {
  green: 70,
  amber: 40,
};

export const getScoreColor = (score) => {
  if (score === null || score === undefined) return 'text-dimmed';
  if (score >= SCORE_THRESHOLDS.green) return 'text-green-400';
  if (score >= SCORE_THRESHOLDS.amber) return 'text-amber-400';
  return 'text-red-400';
};

// ── Platform display config ─────────────────────────────────────
export const PLATFORM_CONFIG = {
  '2ememain':             { color: 'text-blue-400',    dotColor: 'bg-blue-400',    hex: 'rgba(96,165,250,0.5)' },
  'gocar':               { color: 'text-cyan-400',    dotColor: 'bg-cyan-400',    hex: 'rgba(34,211,238,0.5)' },
  'autoscout24':         { color: 'text-orange-400',  dotColor: 'bg-orange-400',  hex: 'rgba(251,146,60,0.5)' },
  'facebook_marketplace':{ color: 'text-blue-500',    dotColor: 'bg-blue-500',    hex: 'rgba(59,130,246,0.5)' },
  'carmin_marketplace':  { color: 'text-accent-purple',dotColor: 'bg-accent-purple', icon: Store, hex: 'rgba(168,85,247,0.5)' },
  'instagram':           { color: 'text-pink-400',    dotColor: 'bg-pink-400',    hex: 'rgba(244,114,182,0.5)' },
  'facebook':            { color: 'text-blue-500',    dotColor: 'bg-blue-500',    hex: 'rgba(59,130,246,0.5)' },
};

// ── Status colors for platform rows ─────────────────────────────
export const getPlatformStatus = (published, total) => {
  if (total === 0) return 'gray';
  const ratio = published / total;
  if (ratio === 0) return 'gray';
  if (ratio < 0.3) return 'yellow';
  return 'green';
};

// ── Recommendation category config ──────────────────────────────
export const RECOMMENDATION_CATEGORIES = {
  dormant:  { color: 'text-red-400',    bg: 'bg-red-500/[0.06]',    border: 'border-red-500/15' },
  coverage: { color: 'text-amber-400',  bg: 'bg-amber-500/[0.06]',  border: 'border-amber-500/15' },
  social:   { color: 'text-blue-400',   bg: 'bg-blue-500/[0.06]',   border: 'border-blue-500/15' },
  positive: { color: 'text-green-400',  bg: 'bg-green-500/[0.06]',  border: 'border-green-500/15' },
};

// ── Labels (i18n-ready) ─────────────────────────────────────────
export const VISIBILITY_LABELS = {
  cardTitle: 'Visibilité en ligne',
  diffusionCardTitle: 'Visibilité en ligne',
  performanceCardTitle: 'Performance',
  diffusionTooltip: 'Score de couverture de votre stock sur les plateformes d\'annonces, votre vitrine et les réseaux sociaux. Marketplace 60%, Vitrine 25%, Social 15%.',
  performanceTooltip: 'Entrées, ventes et rotation par période. Sélectionnez une période pour voir les détails et l\'évolution.',
  scoreDiffusion: 'Diffusion',
  scorePerformance: 'Performance',
  diffusionSubtitle: 'couverture du stock',
  performanceSubtitle: 'rotation du stock',
  days: 'j',
  manageLink: 'Gérer mes diffusions',
  sectionMarketplace: 'Plateformes d\'annonces',
  sectionSocial: 'Réseaux sociaux',
  sectionVitrine: 'Vitrine',
  vehiclesOnline: 'véhicules en ligne',
  publications: 'pub.',
  reach: 'reach',
  optimizations: 'optimisation(s) suggérée(s)',
  sectionStockHealth: 'Santé du stock',
  stockAvgAge: 'Âge moyen',
  semiMarketplace: 'Plateformes d\'annonces',
  semiSocial: 'Réseaux sociaux',
  semiVitrine: 'Vitrine',
  vitrineTopConsulted: 'Plus consultés',
  vitrineOthers: 'Autres',
  vitrineNoInterest: 'Moins consultés',
};

// ── Vitrine segment colors ──────────────────────────────────────
export const VITRINE_SEGMENT_COLORS = {
  top: { stroke: 'rgba(96,165,250,0.5)', dot: 'bg-blue-400', bar: 'bg-blue-400' },
  rest: { stroke: 'rgba(107,114,128,0.5)', dot: 'bg-gray-500', bar: 'bg-gray-500' },
  noInterest: { stroke: 'rgba(225,29,72,0.45)', dot: 'bg-rose-600', bar: 'bg-rose-600' },
};
